
import { Movil } from "./movil.model";
import { Gtp } from '../shared/gtp';

export class MovilSidebar extends Movil {

    constructor(data: any) {
        super();
        let gtp = new Gtp();
        let color = (data.ult_velocidad == 0) ? 'rojo' : 'verde';
        let ult_transmision = gtp.timeDiff(data.ult_fecha_hora, 'NOW');
        if (ult_transmision.hours >= 12) { color = 'naranja'; }
        this.cod_equipo_rastreo = data.cod_equipo_rastreo;
        this.des_equipo_ratreo = data.des_equipo_ratreo;
        this.fecha_hora = data.ult_fecha_hora;
        this.color = color;
        this.icono = data.cod_tp_vehiculo
    }

}
